<template>
  <div class="service-card-container">
    <div v-if="editable" class="service-card-container__action-btns">
      <button @click="() => $emit('deleteService', id, userServiceId)"><img src="@/assets/icons/trash.svg" alt="usuń"></button>
      <button @click="() => $emit('editService', id)"><img src="@/assets/icons/pencil-square.svg" alt="edytuj"></button>
    </div>
    <div v-if="admin" class="service-card-container__action-btns">
      <button @click="() => {
        $emit('verify')
        verifyLoading = true
      }" v-if="!ishighlighted"><img src="@/assets/icons/check.svg" alt="zweryfikuj" v-if="!verifyLoading"><img src="@/assets/icons/loading.gif" v-else></button>
      <button @click="() => $emit('deleteService', id, userServiceId)"><img src="@/assets/icons/trash.svg" alt="edytuj"></button>
    </div>
    <div v-if="fav" class="service-card-container__action-btns">
      <button @click="() => $emit('deleteFavService', id)"><img src="@/assets/icons/trash.svg" alt="edytuj"></button>
    </div>

    <img :src="img" alt="">
    <div class="service-card-container__verified" v-if="ishighlighted">
      <span>zweryfikowane</span>
    </div>

    <div class="service-card-container__inner">
      <p class="service-card-container__meta">{{ category }}{{ category ? ' • ' : '' }}{{ state }}</p>
      <p class="service-card-container__meta" v-if="providedByName">Specjalista: {{ providedByName }}</p>
      <b>{{ name }}</b>

      <div class="service-card-container__bottom">
        <div class="service-card-container__price-wrap">
          <span class="service-card-container__price">{{ price }} zł</span>
          <img v-if="isAdvance" class="advance-icon" src="@/assets/icons/cash.svg" alt="usługa z zaliczką">
        </div>
        <button v-if="shouldShowActionButton" class="service-card-container__cta" type="button" @click="() => $emit('openServiceModal')">Umów</button>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name:'ServiceCardVue',
  data(){
    return{
      verifyLoading: false
    }
  },
  props:['img', 'name', 'state', 'ishighlighted', 'editable', 'id', 'userServiceId', 'admin', 'price', 'category', 'fav', 'isAdvance', 'shouldShowActionButton', 'providedByName']
}
</script>

<style scoped lang='scss'>
.service-card-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background-color: #fff;
  border: 1px solid #f3f4f6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
  position: relative;
  transition: box-shadow .2s ease, transform .2s ease;
  &:hover{
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(0, 0, 0, .12);
  }
  img{
    width: 100%;
    height: 190px;
    object-fit: cover;
  }

  &__verified{
    background-color: #ecfdf5;
    color: #047857;
    width: 100%;
    text-align: center;
    font-size: 1.2rem;
    font-weight: 700;
    padding: 7px 0;
    border-bottom: 1px solid #d1fae5;
  }

  &__inner{
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 14px;
    b{
      text-align: left;
      font-size: 1.9rem;
      line-height: 1.3;
      color: #1f2937;
      margin: 0;
    }
  }

  &__meta{
    margin: 0;
    font-size: 1.3rem;
    color: #6b7280;
  }

  &__bottom{
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  &__price-wrap{
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__price{
    font-size: 1.9rem;
    font-weight: 700;
    color: #10b981;
    line-height: 1;
  }

  &__cta{
    border: none;
    background: #f3f4f6;
    color: #374151;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 1.3rem;
    font-weight: 600;
    cursor: pointer;
    transition: .2s;
    &:hover{
      background: #10b981;
      color: #fff;
    }
  }

  .advance-icon{
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  &__action-btns{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 8px;
    right: 8px;
    gap: 6px;
    button{
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      cursor: pointer;
      width: 30px;
      height: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>